import { request } from './axios.js'
// export let addIcaurRentCarApi = (data) =>
//   request({ data, url: '/webapp/api/icaurRentCar/add', })


// export let icaurRentCarUserInfoApi = (data) =>
//   request({ data, url: '/webapp/api/icaurRentCar/userInfo'})


// export let timePeriodListApi = (data) =>
//   request({ data, url: '/webapp/api/icaurRentCar/timePeriodList'})



// 客户培训报名
export let customerTrainingApi = (data) =>
  request({ data, url: '/crm/cusInfo/training/submit' })

// 上传作品（multipart/form-data）
export let uploadFileApi = (data) =>
  request({ data, url: '/crm/cusInfo/uploadFile', headers: { 'Content-Type': 'multipart/form-data' } })

// 客户作品提交
export let customerWorkSubmitApi = (data) =>
  request({ data, url: '/crm/cusInfo/work/submit' })

// 客户培训列表
export let customerTrainingListApi = (data) =>
  request({ data, url: '/crm/cusInfo/training/list' })

// 客户作品列表
export let customerWorkListApi = (data) =>
  request({ data, url: '/crm/cusInfo/work/list' })

// 作品入围状态更新
export let workUpdateStatusApi = (data) =>
  request({ data, url: '/crm/cusInfo/work/updateStatus' })

// 奖项排名作品列表（分组）
export let workListByGroupApi = (data) =>
  request({ data, url: '/crm/cusInfo/work/listByGroup' })

